import { Action } from 'redux';

import { isFetchSuccessAction } from '../middleware';
import {
    FETCH_SESSION_NAME,
    SESSION_IDLE_TIMED_OUT, SESSION_START, SESSION_EXPIRED
} from './session.actions';
import {
    INITIAL_SESSION_STATE, SessionState
} from './session.types';

export const sessionReducer = (
    state: SessionState = INITIAL_SESSION_STATE,
    action: Action
): SessionState => {
    if (action.type === SESSION_IDLE_TIMED_OUT) {
        return {
            ...state,
            isIdleTimedOut: true
        };
    } else if (action.type === SESSION_START) {
        return { ...INITIAL_SESSION_STATE };
    } else if (action.type === SESSION_EXPIRED) {
        return {
            ...state,
            isSessionExpired: true
        };
    } else if (isFetchSuccessAction(FETCH_SESSION_NAME, action)) {
        return { ...INITIAL_SESSION_STATE };
    }

    return state;
};
